import { Box, Grid, Typography, useTheme } from '@mui/material';
import { BarChart } from '@mui/x-charts';
import moment from 'moment';

const truncate = (text, max = 28) => {
  if (!text) return '';
  return text.length > max ? `${text.slice(0, max)}...` : text;
};

const formatMinutes = (minutes = 0) => {
  const total = Number(minutes || 0);
  const hrs = Math.floor(total / 60);
  const mins = Math.floor(total % 60);

  if (hrs <= 0) return `${mins}min`;

  return `${hrs}h${mins > 0 ? ` ${mins}min` : ''}`;
};

const LeadTimeDoMes = ({ data = [] }) => {
  const theme = useTheme();

  const chartData = data
    ?.map((item) => ({
      ...item,
      setor: item?.setor || 'SEM SETOR',
      previsto: Number(item?.previsto || 0),
      realizado: Number(item?.realizado || 0),
    }))
    ?.sort((a, b) => b.realizado - a.realizado);

  if (chartData?.length > 0) {
    return (
      <Grid item xs={12} md={6}>
        <Box gap={2} height="100%" display="flex" flexDirection="column">
          <Typography variant="h5" fontWeight="bold">
            Lead Time ({moment().format('MMM/YYYY')})
          </Typography>
          <Box mt="auto" width="100%">
            <BarChart
              layout="horizontal"
              height={Math.max(chartData.length * 60, 200)}
              margin={{ left: 220, top: 50, right: 20 }}
              series={[
                {
                  label: 'Previsto',
                  data: chartData.map((item) => item.previsto),
                  color: theme.palette.primary.light,
                  valueFormatter: (value) => formatMinutes(value),
                },
                {
                  label: 'Realizado',
                  data: chartData.map((item) => item.realizado),
                  color: theme.palette.primary.dark,
                  valueFormatter: (value) => formatMinutes(value),
                },
              ]}
              yAxis={[
                {
                  scaleType: 'band',
                  data: chartData.map((item) => truncate(item.setor)),
                  categoryGapRatio: 0.25,
                },
              ]}
              xAxis={[
                {
                  label: 'Tempo',
                  min: 0,
                  valueFormatter: (value) => formatMinutes(value),
                },
              ]}
            />
          </Box>
        </Box>
      </Grid>
    );
  }

  return null;
};

export default LeadTimeDoMes;
